import React from "react";
import { Outlet } from "react-router-dom";
import CmsSidebar from "./CmsSidebar";
import "./cms.css";

// Layout with a fixed left sidebar (WordPress-style). The sidebar is
// 260px wide on desktop and always visible; content sits in the
// remaining column. On mobile the sidebar becomes an off-canvas drawer
// (handled inside CmsSidebar) and the content occupies the full width
// with a slim top bar.
export default function CmsLayout() {
  return (
    <div className="cms-root min-h-screen bg-slate-50">
      <CmsSidebar />
      <div className="lg:ml-[260px] min-h-screen">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
